module.exports = __webpack_public_path__ + "Images/nodata.svg";


//////////////////
// WEBPACK FOOTER
// ./Images/nodata.svg
// module id = 299
// module chunks = 2